<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>上传管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-card class="box-card table">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>

          <el-form-item label="选择图片">
            <div id="uploadBtn" class="uploader uploader-warning"></div>
            <p>
              相对地址：
              <span id="relativeName"></span>
            </p>
            <p>
              文件大小：
              <span id="size"></span>
            </p>
            <p>
              图片内容：
              <img id="imgTarget">
            </p>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>



<script>
export default {
  data() {
    return {
      ruleForm: {},
      rules: {}
    };
  },
  mounted() {
    /**大小图片前台处理，后台简单处理模式，上传成功后显示图片**/
    $("#uploadBtn").uploader({
      url: "ws://www.gongjuji.net/common/upload",
      fileExts: "jpg;png",
      text: "选择图片",
      more: false, //是否可以上传多个
      auto: true, //是否自动上传
      type: "fixedone", //指定处理类型
      maxWidth: 500,
      maxHeight: 500,
      onSuccess: function(data) {
        //添加到列表,每个图片上传成功都会触发
        $("#relativeName").text(data.relativeName);
        $("#size").text(data.curSize);
        $("#imgTarget").attr(
          "src",
          "http://www.gongjuji.net" + data.relativeName
        );
      }
    });
  }
};
</script>

